export class URLUtils {
    /**
     * Returns a normalized string representation of a URL, omitting query and fragment.
     */
    static toString(url) {
        try {
            const u = typeof url === 'string' ? new URL(url) : url;
            return u.origin + u.pathname;
        }
        catch {
            return '';
        }
    }
    /**
     * Returns a summarized version of a URL that fits within ~80 characters,
     * omitting query, fragment, and truncating long paths if needed.
     */
    static summarize(url) {
        try {
            const u = typeof url === 'string' ? new URL(url) : url;
            const simplified = this.toString(u);
            if (u.origin.length > 80 || simplified.length <= 80) {
                return simplified;
            }
            const maxPathLength = Math.max(0, 80 - u.origin.length);
            const truncatedPath = u.pathname.slice(0, maxPathLength);
            return `${u.origin}${truncatedPath} ...`;
        }
        catch {
            return '';
        }
    }
    /**
     * Compares two URLs for equivalence, ignoring query parameters and fragments.
     */
    static compare(a, b) {
        try {
            const u1 = typeof a === 'string' ? new URL(a) : a;
            const u2 = typeof b === 'string' ? new URL(b) : b;
            return (u1.protocol === u2.protocol &&
                u1.hostname === u2.hostname &&
                u1.port === u2.port &&
                u1.pathname === u2.pathname);
        }
        catch {
            return false;
        }
    }
    static filename(a) {
        const u1 = typeof a === 'string' ? new URL(a) : a;
        return u1.pathname.split('/').pop();
    }
}
//# sourceMappingURL=data:application/json;base64,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